module.exports = __webpack_public_path__ + "img/product-home.28c1de93.png";